export default __webpack_public_path__ + "static/media/example-profile-photo-3.be92f44b.png";